
import { Link } from 'react-router-dom'
import Button from 'ui/src/components/Button'
import LayoutHeading from 'ui/src/components/LayoutHeading'

const ForgotPasswordRequestSuccessView = () => (
    <div className='flex flex-col items-center' data-testid="forgot-password-success-view">
        <LayoutHeading
            title='Request success'
            subtitle="We've send you an email to recover your password"
        />

        <Link to='/auth/signin' className='self-center'>
            <Button variant='solid'>Login</Button>
        </Link>
    </div>
)

export default ForgotPasswordRequestSuccessView
